import { render, staticRenderFns } from "./saasApiSuccessForm.vue?vue&type=template&id=7c70d7ee&scoped=true&"
import script from "./saasApiSuccessForm.vue?vue&type=script&lang=js&"
export * from "./saasApiSuccessForm.vue?vue&type=script&lang=js&"
import style0 from "./saasApiSuccessForm.vue?vue&type=style&index=0&id=7c70d7ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c70d7ee",
  null
  
)

export default component.exports